import React from 'react';
import { Link } from 'react-router-dom';
import { CityChip } from '../ui/CityChip';
import { Button } from '../ui/Button';
import { MapPin } from 'lucide-react';
const cities = ['Brighton', 'Fenton', 'Hartland', 'Howell', 'Milford', 'South Lyon', 'White Lake'];
export function AreasServed() {
  return <section className="py-20 relative overflow-hidden" data-id="element-23">
      {/* Background map image with lighter overlay - aligned to bottom */}
      <div className="absolute inset-0 z-0" data-id="element-24">
        <div className="absolute inset-0 bg-white/70 z-10" data-id="element-25" />
        <div className="absolute inset-0 bg-cover bg-bottom bg-no-repeat" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/xu8kkfdx7cPC8aCoq1r5DS/map.png)'
      }} data-id="element-26" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-27">
        <div className="flex items-center justify-center mb-4" data-id="element-28">
          <MapPin className="w-8 h-8 text-primary mr-3" data-id="element-29" />
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-30">
            Proudly Serving Local Families
          </h2>
        </div>

        <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto mb-8 font-medium leading-relaxed" data-id="element-31">
          Brighton's premier family-owned martial arts school — serving your
          community with expert instruction.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-32">
          {cities.map(city => <CityChip key={city} city={city} data-id="element-33" />)}
        </div>

        {/* Strong CTA */}
        <div className="bg-gradient-to-r from-primary to-primary-dark rounded-2xl p-8 md:p-10 text-white shadow-xl max-w-4xl mx-auto" data-id="element-34">
          <h3 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-35">
            Ready to Start Your Family's Martial Arts Journey?
          </h3>
          <p className="text-lg text-blue-100 mb-6 max-w-2xl mx-auto" data-id="element-36">
            Join hundreds of local families building confidence, discipline, and
            character. Limited spots available for our 4-week trial program.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-37">
            <Link to="/trial" data-id="element-38">
              <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none min-w-[200px]" data-id="element-39">
                Claim Your Trial Now
              </Button>
            </Link>
            <a href="tel:8107753153" data-id="element-40">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/10 min-w-[200px]" data-id="element-41">
                Call (810) 775-3153
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}